import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import routePathSegments, { routeNames } from '../../../routeSegments'
import useModule from '../../../hooks/useModule'

/**
 * The CoInvestorLayOut function renders a component that displays co-investors and provides a link to
 * view all co-investors.
 * @returns The CoInvestorLayOut component is returning JSX elements.
 */
const CoInvestorLayOut = ({CO_INVESTOR_TAB,investorName}) => {
    const { investorId } = useParams()
    const { primaryMasterId } = useModule()

    return (
        <div className="px-4 bg-[#EDEDED] w-[100%]">
            <div className=" mt-4 bg-white border  overflow-hidden sm:rounded-lg">
                <div className="px-4 pt-4 sm:px-6">
                    <div className="flex justify-between mb-3">
                        <h3 className=" text-[14pt] leading-[19pt] text-[#333333] lg:text-[18px] lg:leading-[22px] font-semibold">Co-investors</h3>
                        {/* <NavLink to={`/${primaryMasterId == 1 ? 'pe' : 'vc' }/co-investors`} state={{investorId:investorId,typeId:primaryMasterId}} className="font-sans_medium_body text-base text-[#A3751F] text-[13.5px] font-bold px-2">View All</NavLink> */}
                        <NavLink target='_blank' to={primaryMasterId == 1 ? routeNames.peCoInvestorById(investorId): routeNames.vcCoInvestorById(investorId)} state={{investorId:investorId,typeId:primaryMasterId}} className="font-sans_medium_body text-base text-[#A3751F] text-[13.5px] font-bold px-2">View All</NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CoInvestorLayOut
